import { history } from "../../src/index";

import * as types from '../constants/teamdetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as userDetailsTypes from '../constants/userdetails';
import * as teamdetailsApi from '../api/teamdetails';

export function resetTeam() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEAM_RESET });
    }
}

export function changePreferedTeamIdUser(loginUser) {
    // console.log('changePreferedTeamIdUser',loginUser)
    return dispatch => {
        dispatch({ type: userDetailsTypes.USER_PREFFERED_TEAM, data: loginUser });
    }
}

export function fetchTeamDetails(id) {
    // console.log("fetchTeamDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEAM_REQUEST });
        teamdetailsApi.getTeamList(id)
            .then(function (response) {
                // console.log("fetchTeamDetails", response)
                dispatch({ type: types.FETCH_TEAM_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("fetchTeamDetails Error", err)
                dispatch({ type: types.FETCH_TEAM_REQUEST_ERROR });
            });
    }
}

export function fetchTeamDetailsList() {
    // console.log("fetchTeamDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEAM_LIST_REQUEST });
        teamdetailsApi.getTeamList()
            .then(function (response) {
                // console.log("fetchTeamDetailsList", response)
                dispatch({ type: types.FETCH_TEAM_LIST_REQUEST_COMPLETED, data: response.data.CommitteeList });
            })
            .catch(function (err) {
                // console.log("fetchTeamDetailsList Error", err)
                dispatch({ type: types.FETCH_TEAM_LIST_REQUEST_ERROR });
            });
    }
}

export function addTeamDetails(objModel) {
    // console.log("addTeamDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_TEAM_REQUEST });
        teamdetailsApi.addTeam(objModel)
            .then(function (response) {
                // console.log("addTeamDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_TEAM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                }
                else
                    dispatch({ type: types.ADD_TEAM_REQUEST_ERROR });
                dispatch({ type: types.ADD_TEAM_RESET });
                history.push('/team/team-list');
            })
            .catch(function (err) {
                // console.log("addTeamDetails action err", err)
                dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error' });
                dispatch({ type: types.ADD_TEAM_REQUEST_ERROR });
            });
    }
}


export function updateTeamDetails(objModel) {
    // console.log("addTeamDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_TEAM_REQUEST });
        teamdetailsApi.updateTeam(objModel)
            .then(function (response) {
                // console.log("addTeamDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_TEAM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                }
                else
                    dispatch({ type: types.ADD_TEAM_REQUEST_ERROR });
                dispatch({ type: types.ADD_TEAM_RESET });
                history.push('/team/team-list');
            })
            .catch(function (err) {
                // console.log("addTeamDetails action err", err)
                dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error' });
                dispatch({ type: types.ADD_TEAM_REQUEST_ERROR });
            });
    }
}

export function deleteTeamDetails(objModel) {
    // console.log("deleteTeamDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_TEAM_REQUEST });
        teamdetailsApi.deleteTeam(objModel)
            .then(function (response) {
                // console.log("deleteTeamDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_TEAM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                }
                else
                    dispatch({ type: types.ADD_TEAM_REQUEST_ERROR });
                dispatch({ type: types.ADD_TEAM_RESET });
                history.push('/team/team-list');
            })
            .catch(function (err) {
                // console.log("deleteTeamDetails action err", err)
                dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error' });
                dispatch({ type: types.ADD_TEAM_REQUEST_ERROR });
            });
    }
}

export function loadswitchercommittees() {
    // console.log("loadswitchercommittees action call");
    return (dispatch, getState) => {
        // console.log('teamDetails', getState())
        let _state = getState()
        if (_state && _state.teamDetails && _state.teamDetails.switchteamdetailsList && _state.teamDetails.switchteamdetailsList.length > 0) { 
            // console.log('loadswitchercommittees loaded from CACHE',_state.teamDetails.switchteamdetailsList)
        }
        else {
            dispatch({ type: types.FETCH_SWITCH_TEAM_LIST_REQUEST });
            teamdetailsApi.loadswitchercommittees()
                .then(function (response) {
                    console.log("loadswitchercommittees", response)
                    dispatch({ type: types.FETCH_SWITCH_TEAM_LIST_REQUEST_COMPLETED, data: response.data.CommitteeList });
                })
                .catch(function (err) {
                    // console.log("loadswitchercommittees Error", err)
                    // dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error' });
                    dispatch({ type: types.FETCH_SWITCH_TEAM_LIST_REQUEST_ERROR, error: err });
                });
        }
    }
}

export function getTeamUserList(committee_id) {
    // console.log("getTeamUserList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEAM_USER_LIST_REQUEST });
        teamdetailsApi.getTeamUserList(committee_id)
            .then(function (response) {
                // console.log("getTeamUserList", response)
                dispatch({ type: types.FETCH_TEAM_USER_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getTeamUserList Error", err)
                dispatch({ type: types.FETCH_TEAM_USER_LIST_REQUEST_ERROR });
            });
    }
}

export function getCustomerUserList() {
    // console.log("getTeamUserList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEAM_USER_LIST_REQUEST });
        teamdetailsApi.getCustomerUserList()
            .then(function (response) {
                // console.log("getTeamUserList", response)
                dispatch({ type: types.FETCH_TEAM_USER_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getTeamUserList Error", err)
                dispatch({ type: types.FETCH_TEAM_USER_LIST_REQUEST_ERROR });
            });
    }
}


// WEBPACK FOOTER //
// ./actions/teamdetails.js